/* --------- Variabile necesare --------- */
const form = document.querySelector(".formular-contact-wrapper");
const inputs = document.querySelectorAll(".line-wrapper .form-data");
const dataTip = document.querySelector("[data-tip]").dataset.tip;
const dataSource = document.querySelector("[data-source]").dataset.source;
const dataPageTitle =
  document.querySelector("[data-page-title]").dataset.pageTitle;
let thModel = "Fara Model";
const dataLiveAgent =
  document.querySelector("[data-live-agent]").dataset.liveAgent;

if (dataTip == "Formular Camera Copii") {
  form.setAttribute("data-produs", "");
  form.setAttribute("data-produslink", "");

  const linkCamera = document.querySelectorAll("[data-link]");

  linkCamera.forEach((camere) => {
    camere.addEventListener("click", () => {
      form.setAttribute("data-produslink", camere.dataset.link);
    });
  });
}

if (dataTip == "Contact Sistem de Prindere Draperii") {
  try {
    const productVariant = document.querySelectorAll("[data-variant]");

    form.setAttribute("data-variant-form", productVariant[0].dataset.variant);

    productVariant.forEach((variant) => {
      variant.addEventListener("click", () => {
        form.setAttribute("data-variant-form", variant.dataset.variant);
      });
    });
  } catch (error) {
    console.log("Nu s-au gasit variante!");
  }
}

if (dataTip == "Tiny House") {
  const thModels = document.querySelectorAll("[data-th-model]");

  thModels.forEach((model) => {
    model.addEventListener("click", function () {
      thModel = model.dataset.thModel;
    });
  });
}

let htmlMessage = "";
let cli = "";

/* --------- Verifica daca exista inputul "uploadFile" si returneaza un obiect cu 
  datele pe care vrem sa le salvam pentru upload ----------------------------- */
const checkDataLimit = () => {
  let saveLimit = "";
  let saveObligatoriu = "";
  const uploadFile = document.getElementById("uploadFile");
  if (uploadFile) {
    saveLimit = parseInt(document.querySelector("[data-limit]").dataset.limit);
    saveObligatoriu =
      document.querySelector("[data-obligatoriu]").dataset.obligatoriu;

    return { saveLimit: saveLimit, saveObligatoriu: saveObligatoriu };
  }
  return {};
};

document
  .getElementById("Trimite-Mesaj-Mobexpert")
  .addEventListener("click", function () {
    const box = document.querySelector(".formular-contact-wrapper");
    box.style.scrollMarginTop =
      dataSource == "formular-camera-copii-3d" ? "250px" : "50px";
    box.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  });

/* --------- In cazul in care elementul nu exista in html dar este in js si este folosit "addEventListener" 
  pe element, functia "elementListenerMissing" ne scapa de eroarea din consola ------------------------- */
const elementListenerMissing = {
  addEventListener: function () {},
};

/* --------- Upload Check --------- */
const uploadData = checkDataLimit();
const dataLimit = !isObjEmpty(uploadData) ? uploadData.saveLimit : false;
const dataObligatoriu = !isObjEmpty(uploadData)
  ? uploadData.saveObligatoriu
  : false;

/* --------- Verifica daca mail-ul este valid dupa ce selecteaza alt input --------- */
(document.getElementById("mail") || elementListenerMissing).addEventListener(
  "change",
  function () {
    if (!validateEmail(this.value)) {
      document.getElementById("mail").classList.add("error");
      document.querySelector("#email-error").classList.add("icon");
      document.querySelector("#email-error").innerHTML =
        "Adresa de E-mail nu este valida";
    } else {
      document.getElementById("mail").classList.remove("error");
      document.querySelector("#email-error").innerHTML = "";
      document.querySelector("#email-error").classList.remove("icon");
    }
  }
);

/* --------- Verifica daca telefon-ul este valid dupa ce selecteaza alt input --------- */
(document.getElementById("telefon") || elementListenerMissing).addEventListener(
  "change",
  function () {
    if (!validatePhone(this.value)) {
      document.getElementById("telefon").classList.add("error");
      document.querySelector("#telefon-error").classList.add("icon");
      document.querySelector("#telefon-error").innerHTML =
        "Numărul de telefon nu este valid";
    } else {
      document.getElementById("telefon").classList.remove("error");
      document.querySelector("#telefon-error").innerHTML = "";
      document.querySelector("#telefon-error").classList.remove("icon");
    }
  }
);

/* --------- Verifica daca Upload-ul este valid dupa ce selecteaza alt input --------- */
(
  document.getElementById("uploadFile") || elementListenerMissing
).addEventListener("change", function () {
  const files = checkFiles("uploadFile");
  if (files.length > dataLimit) {
    document.getElementById("uploadFile").classList.add("error");
    document.getElementById("check-files").innerHTML = "";
    document.querySelector("#file-error").style.display = "block";
    document.querySelector("#file-error").classList.add("icon");
    document.querySelector("#file-error").innerHTML =
      "Numărul maxim de fișiere este de 5.";
  } else {
    if (files.length > 1) {
      document.querySelector("#file-error").style.display = "none";
    }
    document.getElementById("check-files").innerHTML = htmlMessage;
    document.getElementById("uploadFile").classList.remove("error");
    document.querySelector("#file-error").innerHTML = "";
    document.querySelector("#file-error").classList.remove("icon");
    document.querySelector("#file-error").style.margin = "0";
  }
});

/* --------- Verifica daca variabila este goala --------- */
const isEmpty = (value) => {
  return (
    // null or undefined
    value == null ||
    // has length and it's zero
    (value.hasOwnProperty("length") && value.length === 0) ||
    // is an Object and has no keys
    (value.constructor === Object && Object.keys(value).length === 0) ||
    value == "" ||
    value == " "
  );
};

/* --------- Verificarea datelor dupa ce apasam pe buttonul de trimitere si 
  adaugarea datelor in variabila "data" pentru trimiterea in backend --------- */
const sendData = async () => {
  const inputs = document.querySelectorAll(".line-wrapper .form-data");
  const formData = new FormData();
  let error = false;
  let andUpload = false;
  let data = {};

  data.source = dataSource;
  data.tip = dataTip;
  data.user_agent = navigator.userAgent;
  data.page_url = window.location.href;
  data.remote_ip = isIP(cli) ? cli : "";

  if (dataSource == "formular-contact-bucatarii") {
    data.nume_bucatarie = dataPageTitle;
  }

  if (dataTip == "Tiny House") {
    data.th_tip = document.querySelector("[data-th-tip]").dataset.thTip;
    data.th_model = thModel;
  }

  if (dataSource == "formular-contact-sisteme-prindere-perdele") {
    var dataPageTitleSplit = dataPageTitle.split("/");
    data.nume_draperii =
      dataPageTitleSplit.length > 1
        ? dataPageTitleSplit[1]
        : (data.nume_draperii = dataPageTitle);

    const prod_var = document.querySelector("[data-variant-form]");
    if (prod_var) {
      data.nume_draperii =
        data.nume_draperii + " - model: " + prod_var.dataset.variantForm;
    }
  }

  if (dataSource == "formular-camera-copii-3d") {
    data.link_camera =
      document.querySelector("[data-produslink]").dataset.produslink;

    const dataNumeProdus =
      document.querySelector("[data-produs]").dataset.produs;
    data.produs = dataNumeProdus;
    if (form.dataset.produs == "") {
      document.querySelector("#room-error").classList.add("icon");
      document.querySelector("#room-error").innerHTML =
        "Este necesar să alegi un tip cameră din listă";
      error = true;
    } else {
      document.querySelector("#room-error").innerHTML = "";
      document.querySelector("#room-error").classList.remove("icon");
    }
  }

  if (dataSource == "formular-job") {
    let jobTitleFormularJob =
      document.querySelector("[data-jobtitle]").dataset.jobtitle;
    let magazinFormularJob =
      document.querySelector("[data-magazin]").dataset.magazin;
    magazinFormularJob.replace("  ", " ");
    data.nume_job = jobTitleFormularJob.trim();
    data.nume_magazin = magazinFormularJob.trim();
  }

  if (dataSource == "formular-contact-obloane") {
    data.nume_oblon = dataPageTitle.trim();
  }

  if (dataTip == "Produs Configurabil") {
    data.productSKU = document
      .querySelector("#product-sku")
      .textContent.trim()
      .replace(/\n/g, "");
    data.productTitle = dataPageTitle;
    data.productURL = document.URL;

    if (dataSource == "formular-produs-configurabil-basic") {
      data.pc_tip = "ProdusConfigurabil_Basic";
    } else if (dataSource == "formular-produs-configurabil-flori") {
      data.pc_tip = "ProdusConfigurabil_Green";
    } else if (dataSource == "formular-produs-configurabil-office") {
      data.pc_tip = "ProdusConfigurabil_Office";
    }
  }

  if (dataLiveAgent == "true") {
    data.liveAgent = true;
  }
  

  inputs.forEach((input) => {
    if (input.id == "magazin") {
      if (isEmpty(input.value)) {
        input.classList.add("error");
        document.querySelector("#magazin-error").classList.add("icon");
        document.querySelector("#magazin-error").innerHTML =
          "Este necesar să alegi un magazin din listă";
        error = true;
      } else {
        data[input.id] = input.value;
        input.classList.remove("error");
        document.querySelector("#magazin-error").innerHTML = "";
        document.querySelector("#magazin-error").classList.remove("icon");
      }
    } else if (input.id == "subiect") {
      if (isEmpty(input.value)) {
        input.classList.add("error");
        document.querySelector("#subiect-error").classList.add("icon");
        document.querySelector("#subiect-error").innerHTML =
          "Este necesar să alegi un subiect din listă";
        error = true;
      } else {
        data[input.id] = input.value;
        input.classList.remove("error");
        document.querySelector("#subiect-error").innerHTML = "";
        document.querySelector("#subiect-error").classList.remove("icon");
      }
    } else if (input.id == "mesaj") {
      if (isEmpty(input.value)) {
        input.classList.add("error");
        document.querySelector("#mesaj-error").classList.add("icon");
        document.querySelector("#mesaj-error").innerHTML =
          "Acest câmp este obligatoriu";
        error = true;
      } else {
        data[input.id] = input.value
          .replace(/[\s',\",\\,\/,\n,_,\*,\^,\`]/g, " ")
          .trim();
        input.classList.remove("error");
        document.querySelector("#mesaj-error").innerHTML = "";
        document.querySelector("#mesaj-error").classList.remove("icon");
      }
    } else if (input.id == "uploadFile") {
      const files = checkFiles("uploadFile");
      if (dataObligatoriu == "true" || files.length >= 1) {
        if (files.length > dataLimit) {
          document.getElementById("uploadFile").classList.add("error");
          document.getElementById("check-files").innerHTML = "";
          document.querySelector("#file-error").style.display = "block";
          document.querySelector("#file-error").classList.add("icon");
          document.querySelector("#file-error").innerHTML =
            "Numărul maxim de fișiere este de 5.";
          error = true;
        } else if (dataObligatoriu == "true" && files.length == 0) {
          document.getElementById("uploadFile").classList.add("error");
          document.getElementById("check-files").innerHTML = "";
          document.querySelector("#file-error").style.display = "block";
          document.querySelector("#file-error").classList.add("icon");
          document.querySelector("#file-error").innerHTML =
            "Acest câmp este obligatoriu";
          error = true;
        } else {
          if (files.length > 1) {
            document.querySelector("#file-error").style.display = "none";
          }
          data[input.id] = files;
          document.getElementById("check-files").innerHTML = htmlMessage;
          document.getElementById("uploadFile").classList.remove("error");
          document.querySelector("#file-error").innerHTML = "";
          document.querySelector("#file-error").classList.remove("icon");
        }
      }
    } else if (input.id == "numeComplet") {
      if (isEmpty(input.value)) {
        input.classList.add("error");
        document.querySelector("#nume-error").classList.add("icon");
        document.querySelector("#nume-error").innerHTML =
          "Acest câmp este obligatoriu";
        error = true;
      } else {
        data[input.id] = input.value;
        input.classList.remove("error");
        document.querySelector("#nume-error").innerHTML = "";
        document.querySelector("#nume-error").classList.remove("icon");
      }
    } else if (input.id == "telefon") {
      if (isEmpty(input.value)) {
        input.classList.add("error");
        document.querySelector("#telefon-error").classList.add("icon");
        document.querySelector("#telefon-error").innerHTML =
          "Acest câmp este obligatoriu";
        error = true;
      } else if (!validatePhone(input.value)) {
        input.classList.add("error");
        document.querySelector("#telefon-error").classList.add("icon");
        document.querySelector("#telefon-error").innerHTML =
          "Numărul de telefon este invalid";
        error = true;
      } else {
        data[input.id] = input.value;
        input.classList.remove("error");
        document.querySelector("#telefon-error").innerHTML = "";
        document.querySelector("#telefon-error").classList.remove("icon");
      }
    } else if (input.id == "mail") {
      if (isEmpty(input.value)) {
        input.classList.add("error");
        document.querySelector("#email-error").classList.add("icon");
        document.querySelector("#email-error").innerHTML =
          "Acest câmp este obligatoriu";
        error = true;
      } else if (!validateEmail(input.value)) {
        input.classList.add("error");
        document.querySelector("#email-error").classList.add("icon");
        document.querySelector("#email-error").innerHTML =
          "Adresa de email este invalidă";
        error = true;
      } else {
        data[input.id] = input.value;
        input.classList.remove("error");
        document.querySelector("#email-error").innerHTML = "";
        document.querySelector("#email-error").classList.remove("icon");
      }
    } else if (input.id == "gdpr") {
      if (!input.checked) {
        input.classList.add("error");
        document.querySelector("#check-error").classList.add("icon");
        document.querySelector("#check-error").innerHTML =
          "Vă rugăm să confirmați că sunteți de acord cu termenii și condițiile";
        error = true;
      } else {
        data[input.id] = true;
        input.classList.remove("error");
        document.querySelector("#check-error").innerHTML = "";
        document.querySelector("#check-error").classList.remove("icon");
      }
    } else if (input.id == "functie") {
      if (isEmpty(input.value)) {
        input.classList.add("error");
        document.querySelector("#functie-error").classList.add("icon");
        document.querySelector("#functie-error").innerHTML =
          "Este necesar să alegi o funcție din listă";
        error = true;
      } else {
        data[input.id] = input.value.trim();
        input.classList.remove("error");
        document.querySelector("#functie-error").innerHTML = "";
        document.querySelector("#functie-error").classList.remove("icon");
      }
    }
  });

  console.log(data);
  const newData = !error ? data : false;
  console.log(newData);
    
  if (!isEmpty(newData)) {
    // console.log(JSON.stringify(data, null, 2))
    const formular = document.querySelector(".formular-contact-wrapper");
    formular.classList.add("messaging");
    formular.classList.add("sending");

    //send request
    const response = await postData(data);
    console.log(response);

    if (response.ok == "true") {
      return displaySuccess();
    } else {
      return displayError();
    }
  }
};

const clickButton = () => {
  const submitButton = document.getElementById("Trimite-Mesaj-Mobexpert");

  submitButton.addEventListener("click", sendData);
};

const displaySuccess = () => {
  const formular = document.querySelector(".formular-contact-wrapper");
  formular.classList.remove("sending");
  formular.classList.add("success");

  //display success
  const inputs = document.querySelectorAll(".line-wrapper .form-data");

  inputs.forEach((input) => {
    if (input.id == "gdpr") {
      input.checked = false;
    } else {
      input.value = "";
    }
    if (input.id == "uploadFile") {
      document.querySelector("#file-error").style.display = "block";
      document.getElementById("check-files").innerHTML = "";
    }
  });

  setTimeout(() => {
    formular.classList.remove("messaging");
    formular.classList.remove("success");
  }, 5000);
};

const displayError = () => {
  //error
  const formular = document.querySelector(".formular-contact-wrapper");
  formular.classList.remove("sending");
  formular.classList.add("error");
};

const postData = async (data) => {
  // const url = "http://localhost:5000/api/form/v1/new"
  const url = "https://api-mobexpert.herokuapp.com/api/form/v1/new";
  // const url = "https://api-mobexpert-dev.herokuapp.com/api/form/v1/new" // Test Dev
  const options = checkOptions(data);
  //console.log(options);

  try {
    const response = await fetch(url, options);
    const data = await response.json();

    return data;
  } catch (e) {
    return e;
  }
};

clickButton();

///// General Function
//////////////////////

const validateEmail = (email) => {
  const re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;
  return re.test(String(email).toLowerCase());
};

const validatePhone = (phone) => {
  const re =
    /(\+4|)?(07[0-9]{1}[0-9]{1}|02[0-9]{2}|03[0-9]{2}){1}?(\s|\.|\-)?([0-9]{3}(\s|\.|\-|)){2}$/;
  return re.test(String(phone).toLowerCase());
};

const isIP = (value) => {
  // Expresie regulată pentru verificarea unei adrese IP
  const ipRegex = /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/;

  return ipRegex.test(value);
};

const checkOptions = (data) => {
  if (data.hasOwnProperty("uploadFile")) {
    const formData = new FormData();
    const filesObject = data["uploadFile"];
    const filesArray = filesObjectToArray(filesObject);

    data["uploadFile"].forEach((file) => {
      formData.append(file.name, file);
    });

    formData.append("dataForm", JSON.stringify(data));
    //console.log(formData);
    return {
      method: "POST",
      mode: "cors",
      body: formData,
    };
  } else {
    return {
      method: "POST",
      mode: "cors",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    };
  }
};

const filesObjectToArray = (uploadFiles) => {
  const files = [];
  if (uploadFiles && uploadFiles !== null) {
    for (const [key, file] of Object.entries(uploadFiles)) {
      files.push(file);
    }
  }
  return files;
};

const checkFiles = (filesId) => {
  const files = document.getElementById(`${filesId}`).files;
  const filesToArray = filesObjectToArray(files);
  htmlMessage = "";

  const checkFiles = filesToArray.filter((file) => {
    let error = false;
    if (Number(file.size) > 20971520) {
      htmlMessage += `<p class='error-txt icon' style="color: red">${file.name} (Fișierul a trecut de limita de 20mb)</p>`;
      error = true;
    } else if (!typeOfFile.includes(file.type)) {
      htmlMessage += `<p class='error-txt icon' style="color: red">${file.name} (Tipul fișierului nu este permis)</p>`;
      error = true;
    }
    if (!error) {
      htmlMessage += `<p class='success-txt icon' style="color: #4dca64">${file.name}</p>`;
      return file;
    }
  });
  //console.log(checkFiles);
  if (checkFiles.length == 0) {
    document.querySelector("#file-error").style.display = "block";
    return checkFiles;
  }
  htmlMessage += `<p class='check-txt icon' style="color: #5D90D7">Se ${
    checkFiles.length > 1 ? "trimit" : "trimite"
  } ${checkFiles.length} ${checkFiles.length > 1 ? "fișiere" : "fișier"}</p>`;
  return checkFiles;
};

function isObjEmpty(obj) {
  return Object.keys(obj).length === 0;
}

fetch("https://api.ipify.org?format=json")
  .then((response) => response.json())
  .then((data) => {
    cli = data.ip;
  })
  .catch((error) => {
    cli = "";
  });

const typeOfFile = [
  "image/png", // PNG
  "image/gif", // GIF
  "image/jpeg", // JPEG / PEG
  "image/png", // PNG
  "image/bmp", // BMP
  "audio/mpeg", // MP3
  "video/mp4", // MP4
  "text/plain", // TXT
  "application/pdf", // PDF
  "application/msword", // DOC
  "application/vnd.ms-excel", // XLS
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // XLSX
  "application/vnd.openxmlformats-officedocument.presentationml.presentation", // POWERPOINT
  "application/vnd.oasis.opendocument.text", // FISIERE ODF
  "application/vnd.oasis.opendocument.spreadsheet", // FISIERE ODF
  "application/vnd.oasis.opendocument.presentation", // FISIERE ODF
];

/*JS creare SELECT */
let x, l, ll, selElmnt, a, b, c;
let html, previoushtml, currentItem;
/*look for any elements with the class "custom-select":*/
x = document.getElementsByClassName("custom-select");
l = x.length;
for (let i = 0; i < l; i++) {
  selElmnt = x[i].getElementsByTagName("select")[0];
  ll = selElmnt.length;
  /*for each element, create a new DIV that will act as the selected item:*/
  a = document.createElement("DIV");
  a.setAttribute("class", "select-selected");
  a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
  x[i].appendChild(a);
  /*for each element, create a new DIV that will contain the option list:*/
  b = document.createElement("DIV");
  b.setAttribute("class", "select-items select-hide");
  for (let j = 1; j < ll; j++) {
    /*for each option in the original select element,
    create a new DIV that will act as an option item:*/
    c = document.createElement("DIV");
    c.innerHTML = selElmnt.options[j].innerHTML;
    c.setAttribute("value", selElmnt.options[j].getAttribute("value"));
    c.setAttribute("id", selElmnt.options[j].getAttribute("id"));
    c.addEventListener("click", function (e) {
      /*when an item is clicked, update the original select box,
        and the selected item:*/
      var y, i, k, s, h, sl, yl;

      s = this.parentNode.parentNode.getElementsByTagName("select")[0];
      sl = s.length;
      h = this.parentNode.previousSibling;
      for (i = 0; i < sl; i++) {
        if (this.innerHTML.includes("svg"))
          html =
            this.innerHTML -
            '<svg class="checkmark" viewBox="0 0 48 48" enable-background="new 0 0 48 48"><polygon fill="#000" points="40.6,12.1 17,35.7 7.4,26.1 4.6,29 17,41.3 43.4,14.9"/></svg>';
        else html = this.innerHTML;
        if (s.options[i].innerHTML == html) {
          s.selectedIndex = i;
          h.innerHTML = html;
          h.setAttribute("value", this.getAttribute("value"));
          y = this.parentNode.getElementsByClassName("same-as-selected");
          yl = y.length;
          for (k = 0; k < yl; k++) {
            if (y[k]) {
              y[k].innerHTML = previoushtml;
            }
            y[k].removeAttribute("class");
          }
          this.setAttribute("class", "same-as-selected");
          previoushtml = this.innerHTML;
          this.innerHTML =
            '<svg class="checkmark" viewBox="0 0 48 48" enable-background="new 0 0 48 48"><polygon fill="#000" points="40.6,12.1 17,35.7 7.4,26.1 4.6,29 17,41.3 43.4,14.9"/></svg>' +
            this.innerHTML;
          break;
        }
      }
      h.click();
    });
    b.appendChild(c);
  }
  x[i].appendChild(b);
  a.addEventListener("click", function (e) {
    /*when the select box is clicked, close any other select boxes,
      and open/close the current select box:*/
    e.stopPropagation();
    closeAllSelect(this);
    this.nextSibling.classList.toggle("select-hide");
    this.classList.toggle("select-arrow-active");

    if (previoushtml) {
      currentItem = document.querySelector(`.select-selected`);

      if (typeof currentItem !== "undefined") {
        previousItem = currentItem.innerHTML;
      }
    }
  });
}
function closeAllSelect(elmnt) {
  /*a function that will close all select boxes in the document,
  except the current select box:*/
  var x,
    y,
    xl,
    yl,
    arrNo = [];
  x = document.getElementsByClassName("select-items");
  y = document.getElementsByClassName("select-selected");
  xl = x.length;
  yl = y.length;
  for (let i = 0; i < yl; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i);
    } else {
      y[i].classList.remove("select-arrow-active");
    }
  }
  for (let i = 0; i < xl; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add("select-hide");
    }
  }
}
/*if the user clicks anywhere outside the select box,
then close all select boxes:*/
document.addEventListener("click", closeAllSelect);
